export const RECEIVE_METER_MODELS = 'RECEIVE_METER_MODELS';
export const GET_METER_MODELS = 'GET_METER_MODELS';
export const SET_METER_MODEL = 'SET_METER_MODEL';
export const UPDATE_METER_MODEL = 'UPDATE_METER_MODEL';
export const DELETE_METER_MODEL = 'DELETE_METER_MODEL';
export const FETCH_METER_MODELS = 'FETCH_METER_MODELS';
